export const Date = ({ position = "", data = {} }) => {
  return data.status ? (
    <div
      className={`inline-flex flex-col items-center justify-center px-[9px] py-1.5 relative bg-[#00000080] rounded-md overflow-hidden ${position} hidden-date`}
    >
      <div className="relative w-fit mt-[-1.00px] font-secondary font-medium text-white text-[10px] tracking-[0] leading-[11.5px] whitespace-nowrap">
        {data.month.toUpperCase()}
      </div>

      <div className="relative w-fit font-secondary font-medium text-white text-base tracking-[0] leading-[18.4px] whitespace-nowrap">
        {data.day}
      </div>
    </div>
  ) : (
    <></>
  );
};
